import { render, staticRenderFns } from "./videoDetail.vue?vue&type=template&id=1149b55a&scoped=true"
import script from "./videoDetail.vue?vue&type=script&lang=js"
export * from "./videoDetail.vue?vue&type=script&lang=js"
import style0 from "./videoDetail.vue?vue&type=style&index=0&id=1149b55a&prod&scoped=true&lang=css"
import style1 from "./videoDetail.vue?vue&type=style&index=1&id=1149b55a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1149b55a",
  null
  
)

export default component.exports